var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-box alert-box--right alert-box--top"},_vm._l((_vm.toasts),function(toast,index){return _c('toast',{key:index,attrs:{"type":toast.type,"index":index,"message":toast.message},on:{"close":_vm.destroy}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }